import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const issueNavigatorProjectServicedeskRoute: InvariantJiraRoute = {
	name: 'servicedesk-issues',
	path: '/jira/servicedesk/projects/:projectKey/issues/:navigationItemId?',
};
